import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Slice } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { IndigenousVoicesStorymapIframe } from '../elements/indigenous-voices-storymap-iframe';
const cls = classNames('slice-indigenous-voices-storymap');

// -------- Types -------->

export type SliceIndigenousVoicesStorymapProps = Classable & HasChildren & { 
  entity?: Slice;
};

export const SliceIndigenousVoicesStorymapDefaultProps: Omit<SliceIndigenousVoicesStorymapProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    
  `,
});

const StorymapStyles = breakpoints({
  base: css`
    width: 100%;
    height: 100vh;
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Storymap: styled(IndigenousVoicesStorymapIframe)`${StorymapStyles}`,

};

export const SliceIndigenousVoicesStorymap: Shapeable.FC<SliceIndigenousVoicesStorymapProps> = (props) => {
  const { className, children, entity } = props;


  return (
    <My.Container className={cls.name(className)}>
      <My.Storymap />
    </My.Container>
  );
};

SliceIndigenousVoicesStorymap.defaultProps = SliceIndigenousVoicesStorymapDefaultProps;
SliceIndigenousVoicesStorymap.cls = cls;